module.exports = __webpack_public_path__ + "img/254-09ab5a.png";